import { type TSearchConfigAPIResponse } from '@atlassian/search-client/fetch-search-config';

/**
 * Checks if Rovo is enabled for the given cloudId from site metadata.
 */
export const isRovoEnabled = (
	firstPartyResponse?: TSearchConfigAPIResponse,
	cloudId?: string,
): boolean | undefined => {
	if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) {
		return false;
	}
	return firstPartyResponse.siteMetadata.find((metadata) => metadata.siteId === cloudId)
		?.isRovoEnabled;
};
